<script lang="ts" module>
	export interface DurationProps {
		dataCy: string;
		children?: import('svelte').Snippet;
		class?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { Txt } from '../../Txt';

	let { ...props }: DurationProps = $props();

	let dataCyPrefix = $derived(`${props.dataCy}-duration`);
</script>

<div class={classNames('absolute right-2 top-2 rounded-lg bg-[black]/60 px-3 py-1.5', props.class)}>
	<Txt class="text-gray-50" variant="strong2" dataCy={dataCyPrefix}>
		{@render props.children?.()}
	</Txt>
</div>
